import { useFetchDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import React from "react";
import { useParams } from "react-router-dom";

const useModalMultilanguage = () => {
  const { id } = useParams();

  const { columns: columnsCorporate, dataDetail: dataCorporate } =
    useFetchDetail(ServicesURL.corporate, id || "1", PagesID.corporate);

  return {
    columnsCorporate,
    dataCorporate,
    selectOption: {
      ...(columnsCorporate.find((column: any) => {
        return column.accessorKey === "secondary_languages";
      }) || {}),
      valueOptions: dataCorporate?.secondary_languages,
    },
  };
};

export default useModalMultilanguage;
